import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { BcacSourceGroupComponent } from './bcac-source-group.component'
import { NzToolTipModule } from 'ng-zorro-antd';



@NgModule({
  declarations: [BcacSourceGroupComponent],
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    NzToolTipModule
  ],
  exports: [BcacSourceGroupComponent]
})
export class BcacSourceGroupModule { }
